/** Replaces the {nombre} token with the visitor's name. */
export function withName(text: string, name: string) {
  const clean = name.trim();
  if (!clean) {
    const stripped = text.replace(/\{nombre\},?\s*/g, "");
    return stripped.charAt(0).toUpperCase() + stripped.slice(1);
  }
  return text.replace(/\{nombre\}/g, clean);
}

export function formatName(raw: string) {
  const first = raw.trim().split(/\s+/)[0] ?? "";
  return first ? first.charAt(0).toUpperCase() + first.slice(1).toLowerCase() : "";
}
